"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const formik_1 = require("formik");
const nmr_load_save_1 = require("nmr-load-save");
const react_1 = require("react");
const Yup = __importStar(require("yup"));
const PreferencesContext_1 = require("../../../context/PreferencesContext");
const GroupPane_1 = require("../../../elements/GroupPane");
const Label_1 = __importDefault(require("../../../elements/Label"));
const FormikCheckBox_1 = __importDefault(require("../../../elements/formik/FormikCheckBox"));
const usePanelPreferences_1 = require("../../../hooks/usePanelPreferences");
const PreferencesContainer_1 = require("../../extra/preferences/PreferencesContainer");
const AnalysisTablePreferences_1 = require("./AnalysisTablePreferences");
const LegendsPreferences_1 = __importDefault(require("./LegendsPreferences"));
const MultipleAnalysisCodeEditor_1 = __importDefault(require("./MultipleAnalysisCodeEditor"));
function getMultipleSpectraAnalysisData(preferences) {
    return Object.keys(preferences.analysisOptions.columns).map((key) => ({
        ...preferences.analysisOptions.columns[key],
        tempKey: key,
    }));
}
const preferencesSchema = Yup.object({
    analysisOptions: Yup.object({
        columns: Yup.lazy((data) => {
            return Yup.array().of(columnSchema(data));
        }),
    }),
    legendsFields: Yup.array().of(Yup.object({
        jpath: Yup.array().of(Yup.string()).min(1),
    })),
});
// TODO: remove this hacky use of ref.
function MultipleSpectraAnalysisPreferences({ data, activeTab, onAfterSave }, ref) {
    const refForm = (0, react_1.useRef)();
    const panelPreferences = (0, usePanelPreferences_1.usePanelPreferences)('multipleSpectraAnalysis', activeTab);
    const preferences = (0, PreferencesContext_1.usePreferences)();
    const columns = getMultipleSpectraAnalysisData(panelPreferences);
    (0, react_1.useImperativeHandle)(ref, () => ({
        saveSetting() {
            refForm.current.submitForm();
        },
    }));
    function submitHandler(values) {
        onAfterSave?.(true);
        preferences.dispatch({
            type: 'SET_SPECTRA_ANALYSIS_PREFERENCES',
            payload: { data: values, nucleus: activeTab },
        });
    }
    return ((0, jsx_runtime_1.jsx)(PreferencesContainer_1.PreferencesContainer, { style: { backgroundColor: 'white' }, children: (0, jsx_runtime_1.jsx)(formik_1.Formik, { innerRef: refForm, initialValues: {
                ...panelPreferences,
                analysisOptions: { ...panelPreferences?.analysisOptions, columns },
            }, enableReinitialize: true, validationSchema: preferencesSchema, onSubmit: submitHandler, children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(GroupPane_1.GroupPane, { text: "Legends", style: {
                            header: { color: 'black' },
                            container: { padding: '5px' },
                        }, children: (0, jsx_runtime_1.jsx)(LegendsPreferences_1.default, {}) }), (0, jsx_runtime_1.jsx)(GroupPane_1.GroupPane, { text: "General", style: {
                            header: { color: 'black' },
                            container: { padding: '5px' },
                        }, children: (0, jsx_runtime_1.jsx)(Label_1.default, { title: "Enable resort spectra", htmlFor: "resortSpectra", children: (0, jsx_runtime_1.jsx)(FormikCheckBox_1.default, { name: "resortSpectra" }) }) }), (0, jsx_runtime_1.jsx)(GroupPane_1.GroupPane, { text: "Columns Settings ", style: {
                            header: { color: 'black' },
                            container: { padding: '5px' },
                        }, children: (0, jsx_runtime_1.jsx)(AnalysisTablePreferences_1.AnalysisTablePreferences, {}) }), (0, jsx_runtime_1.jsx)(GroupPane_1.GroupPane, { text: "Execute code ", style: {
                            header: { color: 'black' },
                            container: { padding: '5px' },
                        }, children: (0, jsx_runtime_1.jsx)(MultipleAnalysisCodeEditor_1.default, { data: data }) })] }) }) }));
}
function columnSchema(columns) {
    return Yup.object().shape({
        tempKey: Yup.string()
            .required()
            .test('unique', 'must be unique column name', function check(columnName) {
            const colsFrequency = {};
            let index = 0;
            for (const column of columns) {
                if (column.tempKey === columnName) {
                    if (colsFrequency[column.tempKey]) {
                        colsFrequency[column.tempKey].push(index);
                    }
                    else {
                        colsFrequency[column.tempKey] = [index];
                    }
                }
                index++;
            }
            const errors = [];
            for (const key in colsFrequency) {
                const indexes = colsFrequency[key];
                if (indexes.length > 1) {
                    errors.push(new Yup.ValidationError(`${key} nucleus must te be unique`, key, this.path));
                }
            }
            return new Yup.ValidationError(errors);
        }),
        formula: Yup.string().test('required', 'Pease enter formula field', function checkRequired() {
            const errors = [];
            for (const column of columns) {
                if (column?.type === nmr_load_save_1.AnalysisColumnsTypes.FORMULA &&
                    (!column.formula || column.formula === '')) {
                    errors.push(new Yup.ValidationError(`${column.tempKey} formula value is required`, column.formula, this.path));
                }
            }
            return new Yup.ValidationError(errors);
        }),
        index: Yup.string().required(),
    });
}
exports.default = (0, react_1.forwardRef)(MultipleSpectraAnalysisPreferences);
